import React from "react";
import { FiImage } from "react-icons/fi";

export default function MediaAlbumsEmptyState() {
  return (
    <div className="flex min-h-[280px] items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-3xl text-slate-400 dark:bg-slate-800 dark:text-slate-500">
          <FiImage />
        </div>

        <h3 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
          Aucun album photo trouvé
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          Créez un premier album pour composer le carrousel de la page
          d’accueil ou présenter les photos de la commune.
        </p>
      </div>
    </div>
  );
}